<template functional>
  <thead>
    <slot />
  </thead>
</template>

<script>
export default {
    name: 'BaseTableHead',
};
</script>
